import { toast } from 'react-toastify';

export const getToastConfig: any = (timeout: number, position?: string) => {
    return {
        position: position ? position : "top-right",
        autoClose: timeout,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    }
}

export const showSuccessMessage = (msg: string, position?: string) => {
    toast.success(msg, getToastConfig(2000, position));
}

export const showErrorMessage = (error: string, position?: string) => {
    toast.error(error, getToastConfig(2000, position));
}
export const showInfoMessage = (info: string, position?: string) => {
    toast.info(info, getToastConfig(3000, position));
}
export const showWarningMessage = (warning: string, position?: string) => {
    toast.warning(warning, getToastConfig(3000, position));
}
